import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { Url } from '@core/enums/url.enum';

import { AuthenticationService } from '../services/authentication.service';

export const isAuthGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const loginSsoUrlTree = router.createUrlTree([Url.LoginSso]);

  return authenticationService.checkAuth().pipe(
    map(({ isAuthenticated }) => isAuthenticated || loginSsoUrlTree),
    catchError(() => of(loginSsoUrlTree)),
  );
};
